import AllProductData from "../Components/Home/NewDesign/Products/AllProductData";
import { Link } from "react-router-dom";

function PageNotFound() {
  return (
    <>
      <div className="mt-[5em]">
        <h1 className="text-[5em]">404</h1>
        <h1 className="text-[2em] md:text-[4em]">Page Not Found</h1>
      </div>
      <button className="my-[3em] py-[.7em] px-[1em] rounded-md bg-[#2ad1d1]">
        <Link className=" font-bold" to="/">
          GO TO HOME PAGE
        </Link>
      </button>
      <div>
        <AllProductData ProductCount={8} />
      </div>
      <button className="my-[3em] py-[.7em] px-[1em] rounded-md bg-[#2ad1d1]">
        <Link className=" font-bold" to="/productPage">
          View All
        </Link>
      </button>
    </>
  );
}

export default PageNotFound;
